let cfsListRoutePromise: ReturnType<typeof importCFSListRoute> | null = null;
let activeCFSListRoutePromise: ReturnType<
  typeof importActiveCFSListRoute
> | null = null;

const importCFSListRoute = () => import('@/pages/CFS/List');

const importActiveCFSListRoute = () => import('@/pages/CFS/ActiveCFSList');

export const loadCFSListRoute = async () => {
  cfsListRoutePromise ??= importCFSListRoute();
  return cfsListRoutePromise;
};

export const loadActiveCFSListRoute = async () => {
  activeCFSListRoutePromise ??= importActiveCFSListRoute();
  return activeCFSListRoutePromise;
};
